import { isDateRangeInvalid } from "../../components/CustomDateRangeInput";

export const validateRateChartCreation = (values: any, excludeDates: any) => {
  const errors: any = {};

  if (!values.startedAt) {
    errors.startedAt = "The startedAt is required";
  }

  if (!values.endedAt) {
    errors.age = "The endedAt is required";
  }

  if (!values.invoiceIssuedAt) {
    errors.invoiceIssuedAt = "The invoiceIssuedAt is required";
  }

  if (values.startedAt && values.endedAt) {
    if (isDateRangeInvalid(values.startedAt, values.endedAt, excludeDates)) {
      errors.endedAt = "The date range invalid";
    }
  }

  return errors;
};
